function showModalAddsToCart({currentPrices, picture, name, vc}) {
    modals.openModal(null, "#adds-to-cart", modal => {
        const wrapper = modal.querySelector('.js-adds-to-cart');

        let popupTitle = 'Товар добавлен в корзину';
        let article = 'Артикул';
        let continueBuy = 'Продолжить покупки';
        let goToCart = 'Перейти в корзину';

        switch (window.lang) {
            case 'en':
                popupTitle = 'Product added to cart';
                article = 'Article';
                continueBuy = 'Continue';
                goToCart = 'Go to cart';

                break;
        }

        let price = '';

        if (currentPrices) {
            if (+currentPrices.PERCENT > 0) {
                price = `
                    <div class="adds-to-cart__price _sale">
                        <div class="product-card__price-info-old">
                            <span class="product-card__price-info-old-value">
                                ${currentPrices.BASE_PRICE}
                                <span class="rub">
                                    <i>руб.</i>
                                </span>
                            </span>
                            <span class="product-card__price-info-old-sale">–${currentPrices.PERCENT}%</span>
                        </div>
                        <div class="product-card__price-info-current">
                            <strong class="product-card__price-info-current-value product-card__price-info-current-value--sale">
                                ${currentPrices.PRICE}
                                <span class="rub">
                                    <i>руб.</i>
                                </span>
                            </strong>
                        </div>
                    </div>
                `
            } else {
                price = `
                    <div class="adds-to-cart__price">
                        <div class="product-card__price-info-current">
                            <strong class="product-card__price-info-current-value">
                                ${currentPrices.PRICE}
                                <span class="rub">
                                    <i>руб.</i>
                                </span>
                            </strong>
                        </div>
                    </div>
                `
            }
        }

        wrapper.innerHTML = `
            <h2 class="modal__title${picture ? '' : ' _min'}">${popupTitle}</h2>
            <div class="adds-to-cart__info">
                ${picture ? `
                    <div class="adds-to-cart__image">
                        <img src="${picture}" alt="${name}" width="162" height="162">
                    </div>
                ` : ''}
                <div class="adds-to-cart__content">
                    ${name ? `
                        <p class="adds-to-cart__title">${name}</p>
                    ` : ''}
                    ${vc ? `
                        <span class="adds-to-cart__vc">${article}: ${vc}</span>
                    ` : ''}
                    ${price}
                </div>
            </div>
            <div class="adds-to-cart__buttons">
                <button data-modal-close class="button button--trans" onclick="ym(53957554,'reachGoal','clickContinue');">${continueBuy}</button>
                <a href="/cabinet/basket/" class="button">${goToCart}</a>
            </div>
        `
    })
}
